export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getSubwayStationList: function getSubwayStationList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subway_station/get",
        method: "get",
        params: data
      });
    },
    addSubwayStation: function addSubwayStation() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subway_station/create",
        method: "post",
        data: data
      });
    },
    updateSubwayStation: function updateSubwayStation() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subway_station/update",
        method: "post",
        data: data
      });
    },
    updateSubwayStationSort: function updateSubwayStationSort() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/subway_station/updateSort",
        method: "post",
        data: data
      });
    }
  };
});